import React from 'react';

export const getFavIcon = (variant) => (
  <link rel="icon" type="image/x-icon" href={`/static/favicon${variant ? `-${variant}` : ''}.ico`} />
);
